import DesignPlaceholder from '@99designs/common/components/DesignPlaceholder/DesignPlaceholder';
import Icon from 'launch/components/Icon';
import React from 'react';
import { Designer } from './DesignerDetails';
import FileOverlay from './FileOverlay';
import Img from './Img';
import Paginator from './Paginator';

interface Props {
    designer: Designer;
    enableOverlay?: boolean;
}

interface State {
    selectedIndex: number;
    showFileOverlay: boolean;
}

class DesignCarousel extends React.Component<Props, State> {
    state = {
        selectedIndex: 0,
        showFileOverlay: false,
    };

    get hasPrev() {
        return this.state.selectedIndex > 0;
    }

    get hasNext() {
        return this.state.selectedIndex < this.props.designer.profile.designs.length - 1;
    }

    prev = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        if (this.hasPrev) {
            this.setState(state => ({ selectedIndex: state.selectedIndex - 1 }));
        }
    };

    next = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        if (this.hasNext) {
            this.setState(state => ({ selectedIndex: state.selectedIndex + 1 }));
        }
    };

    showFileOverlay = () => {
        if (this.props.enableOverlay) {
            this.setState({ showFileOverlay: true });
        }
    };

    render() {
        const { designs } = this.props.designer.profile;

        if (designs.length == 0) {
            return (
                <div className="design-carousel">
                    <div className="design-carousel__content">
                        <div className="design-carousel__viewport">
                            <DesignPlaceholder size="large" icon={'design-1'}>
                                {__('No designs available')}
                            </DesignPlaceholder>
                        </div>
                    </div>
                    <div className="design-carousel__paginator">
                        <Paginator steps={1} selectedIndex={0} />
                    </div>
                </div>
            );
        }

        return (
            <>
                <div className="design-carousel">
                    <div className="design-carousel__content">
                        {designs.length > 0 && (
                            <div
                                className={`design-carousel__control ${
                                    this.props.enableOverlay
                                        ? 'design-carousel__control--clickable'
                                        : ''
                                }`}
                                onClick={this.showFileOverlay}
                            >
                                {this.hasPrev && (
                                    <button
                                        className="design-carousel__control__prev"
                                        onClick={this.prev}
                                    >
                                        <Icon icon="left-4" />
                                    </button>
                                )}
                                {this.hasNext && (
                                    <button
                                        className="design-carousel__control__next"
                                        onClick={this.next}
                                    >
                                        <Icon icon="right-4" />
                                    </button>
                                )}
                            </div>
                        )}
                        <div className="design-carousel__viewport">
                            <div
                                className="design-carousel__items"
                                style={{
                                    transform: `translateX(-${this.state.selectedIndex * 100}%)`,
                                }}
                            >
                                {designs.map((design, idx) => (
                                    <div className="design-carousel__item" key={idx}>
                                        <Img
                                            src={design.image}
                                            alt={design.title}
                                            key={idx}
                                            preload={idx > 0}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="design-carousel__paginator">
                        <Paginator
                            steps={designs.length}
                            selectedIndex={this.state.selectedIndex}
                            onSelectIndex={selectedIndex => this.setState({ selectedIndex })}
                        />
                    </div>
                </div>
                {this.state.showFileOverlay && (
                    <FileOverlay
                        designer={this.props.designer}
                        selectedDesignIndex={this.state.selectedIndex}
                        onClose={() => this.setState({ showFileOverlay: false })}
                        onDesignChange={selectedIndex => this.setState({ selectedIndex })}
                    />
                )}
            </>
        );
    }
}

export default DesignCarousel;
